import { useState, useEffect, useCallback } from 'react';
import { LOCK_CODE } from '../constants/recipeConstants';

const LockScreen = ({ onUnlock }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const handleDigit = useCallback((digit) => {
    setError(false);
    setCode((prev) => (prev.length >= LOCK_CODE.length ? prev : prev + digit));
  }, []);

  const handleDelete = useCallback(() => {
    setError(false);
    setCode((prev) => prev.slice(0, -1));
  }, []);

  // Kod tamamlandığında otomatik doğrula
  useEffect(() => {
    if (code.length < LOCK_CODE.length) return;

    if (code === LOCK_CODE) {
      onUnlock();
    } else {
      setError(true);
      const timer = setTimeout(() => setCode(''), 600);
      return () => clearTimeout(timer);
    }
  }, [code, onUnlock]);

  // Fiziksel klavye desteği
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key >= '0' && e.key <= '9') {
        handleDigit(e.key);
      } else if (e.key === 'Backspace') {
        handleDelete();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleDigit, handleDelete]);

  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-700 flex items-center justify-center p-4">
      <div className="w-full max-w-xs">
        <div className="text-center mb-8">
          <div className="text-5xl mb-3">🔒</div>
          <h1 className="text-2xl font-bold text-white mb-1">Tarif Defteri</h1>
          <p className="text-slate-300 text-sm">Devam etmek için kodu girin</p>
        </div>

        {/* Kod göstergesi */}
        <div className={`flex justify-center gap-4 mb-8 ${error ? 'animate-pulse' : ''}`}>
          {Array.from({ length: LOCK_CODE.length }).map((_, index) => (
            <div
              key={index}
              className={`w-4 h-4 rounded-full border-2 transition-colors ${
                error
                  ? 'bg-red-500 border-red-500'
                  : index < code.length
                  ? 'bg-white border-white'
                  : 'border-slate-400'
              }`}
            />
          ))}
        </div>

        <p className={`text-center text-sm mb-4 h-5 ${error ? 'text-red-400' : 'text-transparent'}`}>
          Hatalı kod, tekrar deneyin
        </p>

        {/* Tuş takımı */}
        <div className="grid grid-cols-3 gap-4">
          {digits.map((digit) => (
            <button
              key={digit}
              type="button"
              onClick={() => handleDigit(digit)}
              className="h-16 rounded-full bg-white/10 hover:bg-white/20 active:bg-white/30 text-white text-2xl font-semibold transition-colors"
            >
              {digit}
            </button>
          ))}

          <div />

          <button
            type="button"
            onClick={() => handleDigit('0')}
            className="h-16 rounded-full bg-white/10 hover:bg-white/20 active:bg-white/30 text-white text-2xl font-semibold transition-colors"
          >
            0
          </button>

          <button
            type="button"
            onClick={handleDelete}
            disabled={code.length === 0}
            className="h-16 rounded-full text-white text-xl transition-colors hover:bg-white/10 active:bg-white/20 disabled:opacity-30 disabled:hover:bg-transparent"
            aria-label="Sil"
          >
            ⌫
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockScreen;
